import { Login } from "@features/Auth/Login";
import { useOAuthParams } from "@features/Auth/hooks/useOAuthParams";
import { PageContainer } from "./styles";
import { RootLayout } from "@shared/layouts/RootLayout";
import { Helmet } from "react-helmet-async";
import { useSearchParams } from "react-router-dom";
import { useMemo } from "react";
import { useAppName } from "@shared/hooks/useAppName";

export const LoginPage = () => {
  const oauthData = useOAuthParams();
  const [searchParams] = useSearchParams();
  const appName = useAppName();

  const params = useMemo(
    () => ({
      redirect: searchParams.get("redirect"),
      welcome: searchParams.get("welcome"),
    }),
    [searchParams],
  );

  return (
    <RootLayout theme="light">
      <Helmet>
        <title>Sign in - {appName}</title>
        <meta
          name="description"
          content={`Sign in to access your ${appName} account.`}
        />
      </Helmet>
      <PageContainer>
        <Login
          oauthData={oauthData}
          redirect={params.redirect}
          welcome={params.welcome}
        />
      </PageContainer>
    </RootLayout>
  );
};
